import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {filter, map} from "rxjs/operators";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {ResponseModel} from "../models/response.model";

/**
 * Interceptor to manage ResponseModel content and ContentType header
 *
 * @author rodrigo@kissolutions.tech
 */
@Injectable({
  providedIn: 'root'
})
export class ContentInterceptor implements HttpInterceptor {

  private _CONTENT_TYPE = 'application/json';

  constructor() {
  }

  /**
   * Intercepts requests to append `Content-Type` header params
   * Also manipulates response to get payload as body
   *
   * @param req - intercepted request
   * @param next - next interceptor to call
   *
   * @returns response observable
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Some endpoints may not need interceptors
    if (req.headers.get('X-Ignore-Interceptors') === 'true') {
      return next.handle(req);
    }

    // Some endpoints may not need this interceptor
    if (req.headers.get('X-Ignore-ContentInterceptor') === 'true') {
      // We need to remove this header to prevent server side error (this is the last interceptor executed)
      req = req.clone({
        headers: req.headers.delete('X-Ignore-ContentInterceptor')
      });
      return next.handle(req);
    }

    // Request
    if (!(req.body instanceof FormData)) {
      // Aggiunge `Content-Type` solo se non è un FormData
      req = req.clone({
        headers: req.headers.append('Content-Type', this._CONTENT_TYPE)
      });
    }

    // Response
    return next.handle(req).pipe(
      // Skip `sent` event
      filter(res => res.type !== 0),
      map((res: HttpResponse<ResponseModel>) => {
        // Returns `payload` from body as new body
        if (res instanceof HttpResponse &&
          res.headers.get('Content-Type') &&
          res.headers.get('Content-Type').includes('application/json') &&
          res.body) {

          res = res.clone({body: res.body.payload});
        }

        return res;
      })
    );
  }
}
